export default "__VITE_ASSET__8POdEM6j__"